import React from 'react';
import Button from '@mui/material/Button';
import Filter from '@mui/icons-material/FilterList';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import Checkbox from '@mui/material/Checkbox';
import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import { Trans } from 'react-i18next';

type Props = {
  unitTypes: any[],
  invertSelected: any
}

export default (props: Props) => {
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return <Box sx={{display: 'flex', margin: '0px 10%'}}>
    <Box className='units-catalog-title-white' sx={{flexGrow: '1'}}>Catálogo de vehículos</Box>
    <Box>
      <Button variant="text" className='cars-catalog-filter' onClick={handleOpenUserMenu} endIcon={<Filter />}>
        Filtrar
      </Button>
      <Menu
        anchorEl={anchorElUser}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorElUser)}
        onClose={handleCloseUserMenu}
      >
        {props.unitTypes.map((it, index) => {
          return <MenuItem key={index} onClick={() => props.invertSelected(index)}>
          <Checkbox checked={it.selected} className='local-checkbox' />
          <ListItemText primary={<Trans i18nKey={`models.carClassifications.labels.${it.unitType}`}></Trans>} />
        </MenuItem>
        })}
      </Menu>
    </Box>
  </Box>
}